<mat-card>
	<mat-card-header>
		<mat-card-title>
			Resolving Enrollment Details
			<mat-icon *ngIf="isLoading">
				<mat-spinner diameter="20"> </mat-spinner>
			</mat-icon>
			<button class="close-button" mat-mini-fab (click)="closeDialog(false)">
				<mat-icon>close</mat-icon>
			</button>
		</mat-card-title>
	</mat-card-header>

	<mat-card-content>
		<div class="padding-vertical-md row" *ngIf="!isLoading">

			<mat-accordion multi>
				<mat-expansion-panel>
					<mat-expansion-panel-header>
						<mat-panel-title>
							{{getEnabledStudentsCount(schoolEnrollment.STUDENTS) === schoolEnrollment.STUDENTS.length ?
							schoolEnrollment.STUDENTS.length : getEnabledStudentsCount(schoolEnrollment.STUDENTS) + '/'
							+ schoolEnrollment.STUDENTS.length}} Child(ren)
						</mat-panel-title>
					</mat-expansion-panel-header>
					<div class="table-responsive">
						<mat-table [dataSource]="tableDataSources[0]" class="mat-elevation-z1">

							<ng-container matColumnDef="EDIT">
								<mat-header-cell *matHeaderCellDef>
									<button mat-icon-button color="primary"
										(click)="toggleAllStudents(schoolEnrollment)"
										[hidden]="hasAtLeastOneStudent(schoolEnrollment)">
										<mat-icon>check_box_outline_blank</mat-icon>
									</button>
									<button mat-icon-button color="primary"
										(click)="toggleAllStudents(schoolEnrollment)"
										[hidden]="!hasAtLeastOneStudent(schoolEnrollment)">
										<mat-icon>check_box</mat-icon>
									</button>
								</mat-header-cell>
								<mat-cell *matCellDef="let element">
									<button mat-icon-button color="primary"
										(click)="toggleStudent(element, schoolEnrollment)" [hidden]="element.ENABLED">
										<mat-icon>check_box_outline_blank</mat-icon>
									</button>
									<button mat-icon-button color="primary"
										(click)="toggleStudent(element, schoolEnrollment)" [hidden]="!element.ENABLED">
										<mat-icon>check_box</mat-icon>
									</button>
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="MSD_NUMBER">
								<mat-header-cell *matHeaderCellDef> MSD Number </mat-header-cell>
								<mat-cell *matCellDef="let element">
									{{element.MSD_NUMBER}}
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="NAME">
								<mat-header-cell *matHeaderCellDef> Child Name </mat-header-cell>
								<mat-cell *matCellDef="let element"> {{element.NAME}} </mat-cell>
							</ng-container>



							<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
							<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
						</mat-table>
					</div>
					<mat-paginator #paginators
						[pageSizeOptions]="[5, 10, 20, (tableDataSources ? tableDataSources[0] ? tableDataSources[0].data.length > 100 ? tableDataSources[0].data.length : 100 : 100 : 100)]"
						showFirstLastButtons aria-label="Select page of periodic elements"
						[hidden]="tableDataSources[0]?.filteredData?.length === 0">
					</mat-paginator>
				</mat-expansion-panel>

			</mat-accordion>
		</div>

		<form [formGroup]="form" (ngSubmit)="submit()" #enrollmentForm="ngForm">
			<div *ngIf="!isLoading">

				<div class="row">

					<div class="col-lg-6">
						<region-dropdown [isMultiple]="false" (eventEmitterRegioncode)="regionEventEmitter($event)"
							[required]="true" [selectRegionIds]="selectRegionIds">
						</region-dropdown>
					</div>
					<div class="col-lg-6">
						<county-dropdown [isMultiple]="false" (eventEmitterCounty)="countiesEventEmitter($event)"
							[required]="true" [selectCountyIds]="selectCountyIds">
						</county-dropdown>
					</div>

				</div>

				<div class="row">
					<div class="col-lg-6">
						<district-dropdown [isMultiple]="false"
							(eventEmitterSchoolDistrict)="districtsEventEmitter($event)" [required]="true"
							[selectSchoolDistrictIds]="selectSchoolDistrictIds">
						</district-dropdown>
					</div>
					<div class="col-lg-6">
						<school-dropdown [isMultiple]="false" (eventEmitterSchool)="schoolsEventEmitter($event)"
							[selectSchoolIds]="selectSchoolIds">
						</school-dropdown>
					</div>


				</div>

				<hr />

				<div class="row">

					<div class="col-lg-6">
						<div class="row">
							<mat-form-field class="col-lg-12">
								<mat-label>
									Enrollment Type
								</mat-label>
								<mat-select formControlName="enrollmentType"
									(selectionChange)="enrollmentTypeChange($event)">
									<mat-option *ngFor="let enrollmentType of enrollmentTypes"
										[value]="enrollmentType.value">
										{{enrollmentType.display}}
									</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
					</div>

					<div class="col-lg-6">
						<div class="row">
							<app-school-year class="col-lg-12" [label]="'School Year'" [yearType]="'SchoolYear'"
								(performancePeriodEvent)="schoolYearEvent($event)" [currentYearModifier]="0"
								[yearsBack]="1" [yearsForward]="1" [selectSchoolYear]="selectSchoolYear"
								[required]="true">
							</app-school-year>
						</div>
					</div>

				</div>

				<div class="row">

					<div class="col-lg-6">
						<div class="row">
							<grade-dropdown class="col-lg-12" [(chosenGrades)]="chosenGrades" [required]="true"
								(gradeEvent)="gradeEventEmitter($event)" [isMultiple]="false">
							</grade-dropdown>
						</div>
					</div>

					<div class="col-lg-6">
						<div class="row">
							<mat-form-field class="col-lg-12">
								<mat-label>
									Enrollment Date
								</mat-label>
								<input matInput formControlName="enrollmentDate" [matDatepicker]="enrollmentDatePicker"
									(click)="enrollmentDatePicker.open()" startView="multi-year"
									[min]="schoolEnrollment.enrollmentDateOptions.minDate"
									[max]="schoolEnrollment.enrollmentDateOptions.maxDate">
								<mat-datepicker-toggle matSuffix [for]="enrollmentDatePicker"></mat-datepicker-toggle>
								<mat-datepicker #enrollmentDatePicker startView="multi-year"
									[startAt]="schoolEnrollment.enrollmentDateOptions.startAt"></mat-datepicker>
							</mat-form-field>
						</div>
					</div>

				</div>

				<hr />

				<div class="row"
					*ngIf="schoolEnrollment.endOfEligibilityError && schoolEnrollment.schoolEnrollmentDetails.SchoolYear && schoolEnrollment.lowestEligibleStudent">
					<div>
						<div class="warn-font-color italic">
							{{schoolEnrollment.lowestEligibleStudent.PERSON.FIRST_NAME | titlecase}}
							{{schoolEnrollment.lowestEligibleStudent.PERSON.LAST_NAME | titlecase}}'s End of Eligiblity
							date
							{{schoolEnrollment.lowestEligibleStudent.SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE
							| simpleDate}} is ineligiblity for School Year
							{{selectedSchoolYear}}.
						</div>
					</div>
				</div>
				<div class="row"
					*ngIf="schoolEnrollment.hasEnrollmentDateRestriction && schoolEnrollment.schoolEnrollmentDetails.SchoolYear && schoolEnrollment.lowestEligibleStudent">
					<div>
						<div class="warn-font-color italic">
							Enrollment Date's maximum date is set to
							{{schoolEnrollment.lowestEligibleStudent.SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE
							| simpleDate}} because of {{schoolEnrollment.lowestEligibleStudent.PERSON.FIRST_NAME |
							titlecase}}
							{{schoolEnrollment.lowestEligibleStudent.PERSON.LAST_NAME | titlecase}}'s
							({{schoolEnrollment.lowestEligibleStudent.MSD_NUMBER}}) End Of Eligibility Date.
						</div>
					</div>
				</div>

				<div class="margin-top-sm">
					<confirm-popover class="margin-bottom-xs" [buttonType]="'string'" [color]="'primary'"
						[popoverMsg]="'Confirm Resolving Enrollment Details'" [popoverConfirmText]="'Resolve'"
						[buttonTxt]="'Resolve'" [popoverConfirmColor]="'primary'" (onConfirm)="submit()">
					</confirm-popover>
				</div>
				<app-msg class="margin-left-sm" [msg]="msg" *ngIf="msg?.MSG"></app-msg>
			</div>
		</form>
	</mat-card-content>
</mat-card>